export const IBAN_COUNTRIES = [
	'Albania',
	'Andorra',
	'Austria',
	'Belgium',
	'Bosnia and Herzegovina',
	'Bulgaria',
	'Croatia',
	'Cyprus',
	'Czech Republic',
	'Denmark',
	'Estonia',
	'Finland',
	'France',
	'Georgia',
	'Germany',
	'Gibraltar',
	'Greece',
	'Hungary',
	'Iceland',
	'Ireland',
	'Italy',
	'Kosovo',
	'Latvia',
	'Liechtenstein',
	'Lithuania',
	'Luxembourg',
	'Malta',
	'Moldova',
	'Monaco',
	'Montenegro',
	'Netherlands',
	'North Macedonia',
	'Norway',
	'Poland',
	'Portugal',
	'Romania',
	'San Marino',
	'Serbia',
	'Slovakia',
	'Slovenia',
	'Spain',
	'Sweden',
	'Switzerland',
	'Turkey',
	'Ukraine',
	'Bahrain',
	'Egypt',
	'Iran',
	'Iraq',
	'Israel',
	'Jordan',
	'Kuwait',
	'Lebanon',
	'Mauritania',
	'Palestine',
	'Qatar',
	'Saudi Arabia',
	'Tunisia',
	'United Arab Emirates',
	'Dominican Republic',
	'Saint Lucia',
	'Kazakhstan',
	'Pakistan',
];
